import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { idFromObject } from '@sorare/core/src/gql/idFromObject';
import { useQueryLoader } from '@sorare/core/src/hooks/graphql/useQueryLoader';
import { queryLoader } from '@sorare/core/src/lib/navigation/queryLoader';

import { WatchlistPage as WatchlistPageComponent } from '@sorare/marketplace/src/components/watchlists/WatchlistPage';

import type {
  WatchlistPageQuery,
  WatchlistPageQueryVariables,
} from './__generated__/page.graphql.ts';
import type { PageParams } from './__generated__/routeParams.ts';

const WATCHLIST_PAGE_QUERY = gql`
  query WatchlistPageQuery($id: ID!, $sport: Sport!) {
    so5 {
      so5Fixture(type: UPCOMING, eventType: CLASSIC, sport: $sport) {
        slug
      }
    }
    market {
      id
      watchlist(id: $id) {
        slug
        ...WatchlistPage_watchlist
      }
    }
  }
  ${WatchlistPageComponent.fragments.watchlist}
` as TypedDocumentNode<WatchlistPageQuery, WatchlistPageQueryVariables>;

export const loader = queryLoader<PageParams>(
  WATCHLIST_PAGE_QUERY,
  ({ id, sport }) => ({
    id: idFromObject(id),
    sport,
  })
);

const WatchlistPage = () => {
  const { data } = useQueryLoader<WatchlistPageQuery>();

  const so5FixtureSlug = data.so5.so5Fixture?.slug;
  const { watchlist } = data.market;

  return (
    <WatchlistPageComponent
      so5FixtureSlug={so5FixtureSlug}
      watchlist={watchlist}
    />
  );
};

export default WatchlistPage;
